import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { Tooltip, IconButton, Typography, Hidden } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate, lang } from '../../localization'
import { Booking } from '../../types/booking'
import useStyles from './styles/BookingsListTableHeader.styles'

interface BookingsListTableHeaderProps {
  setPage(page: number): void
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      bookingList: Booking
    }>
  >
}

export const BookingsListTableHeader: React.FC<
  BookingsListTableHeaderProps
> = ({ setPage, refetch }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.textFirstElement} variant="body1">
          {getTranslate('Date')}
        </Typography>
      </div>
      <div>
        <Tooltip placement="top" title={getTranslate('Reservation Number')}>
          <Typography className={classes.text}>
            {getTranslate('Res No')}
          </Typography>
        </Tooltip>
      </div>
      <div>
        <Typography className={classes.text}>
          {getTranslate('Provider')}
        </Typography>
      </div>
      <div>
        {lang === 'en' ? (
          <Tooltip placement="top" title={getTranslate('Accommodation Name')}>
            <Typography className={classes.text} variant="body1">
              {getTranslate('Accommodation')}
            </Typography>
          </Tooltip>
        ) : (
          <Typography className={classes.text} variant="body1">
            {getTranslate('Accommodation')}
          </Typography>
        )}
      </div>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Channel')}
        </Typography>
      </div>
      <div>
        {lang === 'en' ? (
          <Tooltip placement="top" title={getTranslate('Booker Name')}>
            <Typography className={classes.text}>
              {getTranslate('Booker')}
            </Typography>
          </Tooltip>
        ) : (
          <Typography className={classes.text}>
            {getTranslate('Booker')}
          </Typography>
        )}
      </div>
      <Hidden lgDown>
        {lang === 'en' ? (
          <div>
            <Tooltip placement="top" title={getTranslate('Number of rooms')}>
              <Typography className={classes.text} variant="body1">
                {getTranslate('Room Count')}
              </Typography>
            </Tooltip>
          </div>
        ) : (
          <div>
            <Typography className={classes.text} variant="body1">
              {getTranslate('Room Count')}
            </Typography>
          </div>
        )}
      </Hidden>
      <Hidden lgDown>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Payable')}
        </Typography>
      </Hidden>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Adotel Status')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('PMS Status')}
        </Typography>
      </div>
      <div>
        <IconButton
          onClick={() => {
            refetch()
            setPage(1)
          }}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
